// import React from "react";
// import "./App.css";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import LandingPage from "./pages/LandingPage";

// function App() {
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<LandingPage />} />
//         </Routes>
//       </BrowserRouter>
//     </div>
//   );
// }

// // export default App;

// import React from "react";
// import "./App.css";
// import { HashRouter, Routes, Route } from "react-router-dom";
// import LandingPage from "./pages/LandingPage";

// function App() {
//   return (
//     <div className="App">
//       <HashRouter>
//         <Routes>
//           <Route path="/" element={<LandingPage />} />
//         </Routes>
//       </HashRouter>
//     </div>
//   );
// }

// export default App;

import React from "react";
import "./App.css";
import LandingPage from "./pages/LandingPage";

function App() {
  return <LandingPage />;
}

export default App;
